<template>
  <div class="login-layout-ui">
    <slot />
  </div>
</template>
